const componentLib = {
    install: function(Vue) {
        Vue.component('CustomPassword', ()=>import('./CustomPassword'));
        Vue.component('CustomDatePicker', ()=>import('./CustomDatePicker'));
        Vue.component('LookMap', ()=>import('./LookMap'));
        Vue.component('CustomUpload', ()=>import('./CustomUpload'));
    }
}
export default componentLib